import { NgClass } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { listDay, MatchList, WorldCupSchedule } from '@data/domain/world-cup.entity';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DialogService } from '@shared/component.dialog';
import { Formatter } from '@shared/helpers/formatter';
import { GetWorldCupScheduleResp } from '@usecase/world-cup/get-world-cup-schedule/get-world-cup-schedule.type';
import { GetWorldCupScheduleUsecase } from '@usecase/world-cup/get-world-cup-schedule/get-world-cup-schedule.usecase';
import { ITEM } from '@utils/constants';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { take } from 'rxjs';

@Component({
  selector: 'world-cup-schedule',
  standalone: true,
  imports: [TranslatePipe, NgClass, CarouselModule ],
  templateUrl: './world-cup-schedule.component.html',
  styleUrl: './world-cup-schedule.component.scss'
})
export class WorldCupScheduleComponent implements OnInit {
  worldCupScheduleData = signal<WorldCupSchedule>({
    start_date: '',
    listDay: []
  });
  isIncoming = signal<boolean>(false);

  private currentDate!: string;
  customCurentDate!: string;
  currentDay!: string;
  startDate!: number;
  indexDay!: number;
  listday: listDay[] = [];
  page: number = ITEM.START_INDEX;
  limit!: number;
  selectedLang = '';

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<img src="assets/icons/chevron-left-dark-blue.svg" alt="Previous" class="custom-prev-img">',
      '<img src="assets/icons/chevron-right-dark-blue.svg" alt="Previous" class="custom-prev-img">'
    ],
    responsive: {
      0: {
        items: 3
      },
      360: {
        items: 4
      },
      600: {
        items: 5
      }
    },
    nav: true
  };

  readonly translateService = inject(TranslateService);
  readonly getWorldCupScheduleUsecase = inject(GetWorldCupScheduleUsecase);
  readonly dialog = inject(DialogService);


  ngOnInit(): void {
    const MOBILE_BREAKPOINT = 768;
    const MOBILE_LIMIT = 2;
    const DESKTOP_LIMIT = 3;
    this.limit = window.innerWidth <= MOBILE_BREAKPOINT ? MOBILE_LIMIT : DESKTOP_LIMIT;

    this.getWorldCupSchedule();

    if (this.isIncoming()) this.scrollHorizontal();
  }

  handleOnLangChange() {
    this.translateService.onLangChange.subscribe((lang) => {
      this.selectedLang = lang.lang;
    });
  }

  getData() {
    this.currentDate = new Date().toISOString();
    this.customCurentDate = Formatter.getDateTime(this.currentDate, this.selectedLang);
    this.currentDay = Formatter.getDay(this.currentDate, this.selectedLang);
    this.worldCupScheduleData().listDay.forEach((resp: listDay) => {
      resp.date = this.isIncoming() ? Formatter.getDateTime(resp.date, this.selectedLang) : Formatter.customDateTime(resp.date, this.selectedLang);
      resp.day = Formatter.getDay(resp.day, this.selectedLang);
      resp.matchLists.forEach((item: MatchList) => {
        item.time = Formatter.getHoursOnly(item.time, this.selectedLang);
      });
    });
  }
  changeDay(event: listDay) {
    this.currentDay = event.day;
  }

  isStarted() {
    const now = Date.now();
    this.startDate = new Date(this.worldCupScheduleData().start_date).getTime();
    return now > this.startDate;
  }

  scrollHorizontal() {
    return this.worldCupScheduleData().listDay.findIndex((resp: listDay) => {
      return resp.date === this.customCurentDate;
    });
  }

  getWorldCupSchedule() {
    this.getWorldCupScheduleUsecase.execute().pipe(take(ITEM.SINGLE_EMISSION)).subscribe({
      next: (res: GetWorldCupScheduleResp) => {
        this.worldCupScheduleData.set(res.data);
        this.handleIsIncoming(res.data.start_date);
        this.getData();
      }
    });
  }

  handleIsIncoming(start_date: string) {
    const CURRENT_TIME = Date.now();
    const START_DATE = new Date(start_date).getTime();

    this.isIncoming.set(CURRENT_TIME > START_DATE);
  }
}
